import MultipleProductsCarousels from '@components/MultpleProductsCarousels';
import { IMultipleProductsCarousels } from './types';
import withSlice from '@slices/withSlice';
import { mapMultipleProductsCarousel } from './mapMultipleProductsCarousels';

const MultipleProductsCarouselsContainer: React.FC<
  IMultipleProductsCarousels
> = ({ items, primary }) => {
  return (
    <MultipleProductsCarousels
      items={items}
      title={primary.title}
      titleIcon={primary.titleIcon}
      isViewItemListEnabled={primary.isViewItemListEnabled}
    />
  );
};

export default withSlice(
  MultipleProductsCarouselsContainer,
  mapMultipleProductsCarousel,
);
